import { takeEvery, takeLatest } from 'redux-saga/effects';
import { call, put, select, delay } from 'redux-saga/effects';
import { browserHistory } from 'react-router';

import * as api from '../../services/address_type/api_address_type';
import * as common from '../sagasCommon';
import * as apiCommon from '../../services/apiCommon';
import * as DocType from '../../constants/constant_doc_types';
import * as SagasType from '../../constants/constant_saga_types';

import messages from '../translation_sagas';

export function* fetchListAddressTypeSaga(feathersApp) {
	yield takeLatest("FETCH_LIST_ADDRESS_TYPE", callFetchListAddressType, feathersApp);
}
function* callFetchListAddressType(feathersApp, action) {
	const { silent, filters } = action;
	yield common.showProgressListTable(silent);
	try {
		const dataParams = {
			filters,
			list_type: DocType.ADDRESS_TYPE
		};
		const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
		yield call(common.doneListTable, { rows: tableData.data, total_rows: tableData.total });
	} catch (error) {
		yield common.showErrorListTable(error);
	}
}

export function* saveAddressTypeSaga(feathersApp) {
	yield takeEvery("SAVE_ADDRESS_TYPE", callSaveAddressType, feathersApp);
}
function* callSaveAddressType(feathersApp, action) {
	const { tenant, user } = yield select();
	try {
		yield put({ type: 'SAVE_RECORD_INPROGRESS' });

		const params = { tenant, user, data: action.data };
		const result = yield call(api.saveAddressType, feathersApp, params);
		yield common.doneSaveRecord(result, action.intl.formatMessage(messages.sagas_address_type));
		yield put({
			type: SagasType.SIMPLE_FORM_SET_DATA,
			data: result
		});
		yield callFetchListAddressType(feathersApp, { silent: true });

	} catch (e) {
		yield common.showErrorSaveRecord(e);
	}
}

export function* deleteAddressTypeFromListSaga(feathersApp) {

	yield takeEvery('DELETE_ADDRESS_TYPE_FROM_LIST', callDeleteAddressTypeFromList, feathersApp);
}

function* callDeleteAddressTypeFromList(feathersApp, action) {
	yield deleteAddressType(feathersApp, action);
	yield delay(2000);
	yield callFetchListAddressType(feathersApp, { silent: true });
}

function* deleteAddressType(feathersApp, action) {
	yield put({ type: 'DELETE_RECORD_INPROGRESS' });
	try {
		const { id } = action;
		let result = null;
		if (id) {
			const state = yield select();
			const { tenant, user } = state;
			const params = { tenant, user, id };
			result = yield call(api.deleteAddressType, feathersApp, params);
			yield put({ type: "DELETE_RECORD_DONE", payload: { id, docType: DocType.ADDRESS_TYPE } });
			yield callFetchListAddressType(feathersApp, { silent: true });
		}
		return result;
	} catch (error) {
		yield put({ type: 'DELETE_RECORD_ERROR', error })
	}
}

export function* deleteAddressTypeSaga(feathersApp) {
	yield takeEvery('DELETE_ADDRESS_TYPE', callDeleteAddressType, feathersApp);
}

function* callDeleteAddressType(feathersApp, action) {
	const result = yield deleteAddressType(feathersApp, action);
	yield delay(2000);
	if (result) {
		browserHistory.push('/admin/address_type');
	}
}

export function* fetchAddressTypeForEditSaga(feathersApp) {
	yield takeEvery('FETCH_ADDRESS_TYPE_BY_ID', callFetchAddressTypeForEdit, feathersApp);
}

function* callFetchAddressTypeForEdit(feathersApp, action) {
	const { tenant, user } = yield select();
	const { id } = action;
	const docType = DocType.ADDRESS_TYPE;
	try {
		if (id) {
			yield put({ type: "FETCH_DATA_BY_ID_INPROGRESS", payload: { docType, id } });
			const fetchParams = { tenant, user, id };
			const doc = yield call(api.fetchAddressTypeById, feathersApp, fetchParams);
			yield common.doneDataById(doc);
			yield put({
				type: SagasType.SIMPLE_FORM_SET_DATA,
				data: doc
			});

		}
	} catch (error) {
		yield put({ type: "FETCH_DATA_BY_ID_ERROR", error: error });
	}
}
